export default "__VITE_ASSET__4f29aa20__"